export default "__VITE_ASSET__BVqhXaL8__"